import React from 'react';
import {
  composeSchema,
  createTextEditor,
  createListEditor,
  createSingleDropdownEditor,
  createNumberEditor,
  createDatePickerEditor,
  createMarkdownRteEditor,
  propertyBuilder,
} from '@refract-cms/core';
import Icon from '@material-ui/icons/Person';
import { CenturySchema } from './century-schema';

export const BioSchema = composeSchema({
  options: {
    alias: 'bio',
    displayName: 'Biography',
    instanceDisplayProps: ({ fornames, surname, status, placeOfPractice }) => {
      const infos = [status && `Status: ${status}`, placeOfPractice && `Place of practice: ${placeOfPractice}`].filter(
        Boolean
      );
      const names = [surname, fornames].filter(Boolean);
      return {
        primaryText: `${names.join(', ')}`,
        secondaryText: infos.join(' • '),
      };
    },
    defaultSort: {
      orderByField: 'surname',
      orderByDirection: 'ASC',
    },
    icon: Icon,
  },
  properties: {
    fornames: {
      type: String,
      displayName: 'Forename(s)',
      editorComponent: createTextEditor(),
    },
    surname: {
      type: String,
      displayName: 'Surname',
      editorComponent: createTextEditor(),
    },
    gender: {
      type: String,
      displayName: 'Gender',
      editorComponent: createSingleDropdownEditor({
        selectOptions: ['Male', 'Female'],
      }),
      defaultValue: 'Male',
    },
    placeOfPractice: {
      type: String,
      displayName: 'Place of Practice',
      editorComponent: createTextEditor(),
    },
    century: propertyBuilder.singleSchemaPicker(CenturySchema, { displayName: 'Century' }),
    // century: {
    //   type: Number,
    //   editorComponent: createNumberEditor({
    //     numberType: 'INT',
    //     maxLength: 20,
    //   }),
    //   displayName: 'Century',
    // },
    yearOfBirth: {
      type: Number,
      editorComponent: createNumberEditor(),
      displayName: 'Year of birth',
    },
    yearOfDeath: {
      type: Number,
      editorComponent: createNumberEditor(),
      displayName: 'Year of death',
    },
    status: {
      type: String,
      editorComponent: createTextEditor(),
      displayName: 'Status',
    },
    description: {
      type: String,
      editorComponent: createMarkdownRteEditor(),
      displayName: 'Description',
    },
    diplomas: {
      type: String,
      editorComponent: createTextEditor(),
      displayName: 'Degrees / Diplomas',
    },
    apprenticeship: {
      type: String,
      displayName: 'Apprenticeship',
      editorComponent: createTextEditor(),
    },
    furtherStudy: {
      type: String,
      editorComponent: createTextEditor(),
      displayName: 'Further Prof Study',
    },
    profileId: {
      type: String,
      editorComponent: (props) => <p>{props.value}</p>,
      displayName: 'Profile ID (For old data)',
    },
  },
});
